import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GerinusService } from '../lib/gerinus.service';

@Injectable()
export class RequestCorrectionService extends GerinusService {
    constructor(public http: HttpClient) {
        super(http);
        this.entityName = 'solicitacao_correcao';
        this.idField = 'SOLC_CodigoSolicitacao';
        this.model = 'SolicitacaoCorrecaoModel';
    }
}
